module.exports = __webpack_public_path__ + "static/media/NvphFanpad1.0892701f.webp";